import React from 'react';
import { connect } from "react-redux";
import {withRouter} from 'react-router-dom';
import ErrorComponent from '../components/errors/ErrorComponent';
import {errorPageData} from "../store/nonSubscriber/action";

class ErrorContainer extends React.Component {


  /* constructor(props) {
    super(props);     
  }  */
  /**
   * @method componentDidMount
   * to load the data after state changed
   */
  componentDidMount() {
    this.props.getPageData();  
  }
  onHide(){

  }

  render() {      
    return (
      <ErrorComponent  pageData={this.props.pageData} />
    )
  }

}
//export default HeaderContainer;

/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  getPageData: errorPageData,
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  pageData: state.nonSubscriber
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorContainer));
